if (!customElements.get('blog-grid')) {
  customElements.define(
    'blog-grid',
    class BlogGrid extends HTMLElement {
      constructor() {
        super();

        this.isLoading = false;
        this.handleLoadMoreClick = this.handleLoadMoreClick.bind(this);
      }

      connectedCallback() {
        this.grid = this.querySelector('[data-blog-grid]');
        this.loadMoreWrap = this.querySelector('[data-load-more-wrap]');
        this.loadMoreButton = this.querySelector('[data-load-more]');

        this.loadMoreButton?.addEventListener('click', this.handleLoadMoreClick);
      }

      disconnectedCallback() {
        this.loadMoreButton?.removeEventListener('click', this.handleLoadMoreClick);
      }

      get sectionId() {
        return this.dataset.sectionId || '';
      }

      get nextUrl() {
        return this.dataset.nextUrl || '';
      }

      set nextUrl(value) {
        if (value) {
          this.dataset.nextUrl = value;
        } else {
          delete this.dataset.nextUrl;
        }
      }

      handleLoadMoreClick(event) {
        event.preventDefault();

        if (this.isLoading || !this.nextUrl) return;

        this.loadMore();
      }

      async loadMore() {
        if (!this.sectionId || !this.grid) return;

        this.isLoading = true;
        this.setLoading(true);

        try {
          const url = new URL(this.nextUrl, window.location.origin);
          url.searchParams.set('section_id', this.sectionId);

          const response = await fetch(url.toString());

          if (!response.ok) {
            throw new Error(`Blog grid request failed: ${response.status}`);
          }

          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const incoming = doc.querySelector('blog-grid');

          if (!incoming) {
            throw new Error('Blog grid markup missing from response');
          }

          this.appendFromIncoming(incoming);
        } catch (error) {
          console.error('Blog grid error:', error);
        } finally {
          this.isLoading = false;
          this.setLoading(false);
        }
      }

      appendFromIncoming(incoming) {
        const incomingGrid = incoming.querySelector('[data-blog-grid]');
        const existingIds = new Set(
          [...this.grid.querySelectorAll('[data-article-id]')].map((card) => card.dataset.articleId),
        );

        [...(incomingGrid?.children || [])]
          .filter((card) => !existingIds.has(card.dataset.articleId))
          .forEach((card) => this.grid.appendChild(card));

        this.nextUrl = incoming.dataset.nextUrl || '';

        if (this.nextUrl) {
          this.loadMoreButton?.setAttribute('href', this.nextUrl);
        } else {
          this.loadMoreWrap?.classList.add('blog__load-more--hidden');
        }
      }

      setLoading(isLoading) {
        if (!this.loadMoreButton) return;

        this.loadMoreButton.setAttribute('aria-busy', isLoading ? 'true' : 'false');

        if (isLoading) {
          this.loadMoreButton.setAttribute('aria-disabled', 'true');
        } else {
          this.loadMoreButton.removeAttribute('aria-disabled');
        }
      }
    },
  );
}
